module.exports = __webpack_public_path__ + "img/image20.c07bfb58.jpg";